import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import Dropdown from '../../components/Dropdown';
import InputField from '../../components/InputField';
import Header from '../../components/Header';

const faqs = [
    {
        question: "<h5>Tapu Masrafı Nasıl Hesaplanır?</h5>",
        answer: [
            "Gayrimenkul devir ve iktisaplarında harç, emlak vergisi değerinden az olmamak üzere, beyan edilen devir ve iktisap bedeli üzerinden hesaplanır.",
            "Hem alıcı hem de satıcı tarafından ayrı ayrı ödenmek üzere ilgili gayrimenkulün beyan edilen satış değerinin binde 20'si (%2) oranında hesaplanır.",
            "Örneğin 100.000 TL'ye satılan bir konut için alıcı 2.000 TL, satıcı 2.000 TL olmak üzere toplamda 4.000 TL tapu masrafı ödenecektir.",
        ],
    },
    {
        question: "<h5>Arsa Tapu Harcı Hesaplama</h5>",
        answer: ["Arsa devir ve iktisap işlemlerinde de konut ve işyerlerinde olduğu gibi alıcı ve satıcıdan ayrı ayrı arsa satış değerinin binde 20 (%2) oranında harç tahsil edilir."],
    },
    {
        question: "<h5>Tapu Harcı Ne Kadar?</h5>",
        answer: [
            "Gayrimenkul satış değerinin %2'si oranında hesaplanır.",
            "Devir işlemlerinde harca ek olarak döner sermaye bedeli de ödenmektedir.",
        ],
    },
    {
        question: "<h5>Tapu Masrafını Kim Öder?</h5>",
        answer: ["Hem alıcı hem de satıcı tarafından ayrı ayrı ödenmektedir."],
    },
    {
        question: "<h5>Harç Bedeli Nereye Yatırılır?</h5>",
        answer: [
            "Devir işleminin yapılacağı yerin bağlı olduğu vergi dairesine veya tapu müdürlüğünün anlaşmalı olduğu bankalara yatırılabilir.",
            "Ödenecek tutar ve banka bilgileri tapu müdürlüğü tarafından kısa mesaj yolu ile alıcı ve satıcıya bildirilir.",
            "E-tahsilat hizmeti veren müdürlüklerde internet üzerinden harç ödemesi de mümkündür.",
            "E-devlet sistemine giriş yaparak tapu harcı borç sorgulama işlemi yapılabilir.",
        ],
    },
    {
        question: "<h5>Tapu Devir Masrafları</h5>",
        answer: ["Devir işlemlerinde en yüksek tutarlı masraf, devir harcıdır. Alıcı ve satıcı için ayrı ayrı olmak üzere gayrimenkul satış değerinin %2'si oranında hesaplanır. Devir işlemlerinde tapu masrafına ek olarak döner sermaye bedeli de ödenir."],
    },
    {
        question: "<h5>Döner Sermaye Bedeli Ne Kadar?</h5>",
        answer: ["Gayrimenkulün bulunduğu yere göre değişmekle birlikte genellikle 1.300 TL civarındadır."],
    },
    {
        question: "<h5>İşyeri veya Konut Satış Fiyatı Tapuda Düşük Gösterilebilir mi?</h5><p>Harç konusunda yaşanan en büyük sorunlardan biri de vatandaşların daha az vergi ödemek adına konut satış fiyatını gerçekte olduğundan daha düşük göstermesidir.</p>",
        answer: [
            "1319 sayılı Emlak Vergisi Kanunu ile göre emlak vergisi değeri belirlenmekte olup satışlarda en düşük bu bedelin beyan edilmesi zorunludur.",
            "Gayrimenkul satış işlemlerinde düşük bedel gösterilmesi yasal bir suç olup tespit edilmesi durumunda vergi cezası kesilir.",
            "Vergi daireleri geçmişe dönük araştırmalar yapmakta ve usulsüzlük tespit edilen satışların sorumlularına vergi cezası uygulamaktadır.",
        ],
    },
];

const hesapTurleri = [{ text: "Harç tutarı ile satış değeri hesaplama", value: 1 }, { text: "Satış değeri ile harç tutarı hesaplama", value: 2 }];

const IsGunuHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

	const [hesapTuru, setHesapTuru] = useState(null);
	const [tapuHarciTutari, setTapuHarciTutari] = useState(null);
	const [satisDegeri, setSatisDegeri] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}
            setHesapTuru(Number(decodeURIComponent(atob(query.get('hesapTuru')))));
            setSatisDegeri(Number(decodeURIComponent(atob(query.get('satisDegeri')))));
            setTapuHarciTutari(Number(decodeURIComponent(atob(query.get('tapuHarciTutari')))));
			setCalculated(true);
		}
        
		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
        let newResults = [];
        const ratio = 0.02;

		if (hesapTuru === 1 && tapuHarciTutari !== null) {
            newResults = [
                { text: "Alıcının Ödeyeceği Tapu Harcı (%2)", value: tapuHarciTutari / 2 },
                { text: "Satıcının Ödeyeceği Tapu Harcı (%2)", value: tapuHarciTutari / 2 },
                { text: "Toplam Tapu Harcı (%4)", value: tapuHarciTutari },
                { text: "Satış Değeri", value: tapuHarciTutari / (ratio * 2) },
            ];

            setHideAll(true);

            const params = new URLSearchParams({
				results: btoa(encodeURIComponent(JSON.stringify(newResults))),
				hesapTuru: btoa(encodeURIComponent(hesapTuru.toString())),
				tapuHarciTutari: btoa(encodeURIComponent(tapuHarciTutari.toString())),
			});

			navigate(`${window.location.pathname}?${params.toString()}`);
			navigate(0);
		} else if (hesapTuru === 2 && satisDegeri !== null){
            newResults = [
                { text: "Alıcının Ödeyeceği Tapu Harcı (%2)", value: satisDegeri * ratio },
                { text: "Satıcının Ödeyeceği Tapu Harcı (%2)", value: satisDegeri * ratio },
                { text: "Toplam Tapu Harcı (%4)", value: satisDegeri * ratio * 2 },
                { text: "Satış Değeri", value: satisDegeri }
            ];

            setHideAll(true);

            const params = new URLSearchParams({
				results: btoa(encodeURIComponent(JSON.stringify(newResults))),
				hesapTuru: btoa(encodeURIComponent(hesapTuru.toString())),
				satisDegeri: btoa(encodeURIComponent(satisDegeri.toString())),
			});

			navigate(`${window.location.pathname}?${params.toString()}`);
			navigate(0);
        } else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

    return (
        <>
            <Helmet>
                <title>Tapu Harcı Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Tapu harcı hesaplama, bir gayrimenkulün alım-satım işlemi sırasında ödenmesi gereken harç miktarını belirlemek için yapılır." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>Tapu Harcı Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">Tapu Harcı Hesapla</h1>
                    <p>Tapu harcı hesaplama, bir gayrimenkulün alım-satım işlemi sırasında ödenmesi gereken harç miktarını belirlemek için yapılır.</p>
                    
                    <Dropdown label="Hesaplama Türünü Seçiniz" options={hesapTurleri} selectedOption={hesapTuru} setSelectedOption={setHesapTuru} />
                    
                    {hesapTuru === 1 && <InputField label="Tapu Harcı Tutarı" type="number" trailText="TL" value={tapuHarciTutari} setValue={setTapuHarciTutari} />}
                    {hesapTuru === 2 && <InputField label="Satış Değeri" type="number" trailText="TL" value={satisDegeri} setValue={setSatisDegeri} />}
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
            </section>
            
            <Footer faqs={faqs} faqTitle="Tapu Harcı Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(IsGunuHesaplama);
